import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './Funnel.css';

// Voronka: har bosqich — nomi, qiymati va birinchi bosqichga nisbatan ulushi (chiziq uzunligi).
// items: [{ key?, label, value, percent? }]; percent berilmasa birinchi qiymatdan hisoblanadi.
const Funnel = forwardRef(function Funnel({ items = [], className, ...rest }, ref) {
  const base = Number(items[0]?.value) || 0;
  return (
    <ul {...rest} ref={ref} className={cx('ui-funnel', className)}>
      {items.map((item, index) => {
        const percent =
          item.percent !== undefined ? item.percent : base ? Math.round((Number(item.value) / base) * 100) : 0;
        const width = Math.max(4, Math.min(100, percent));
        return (
          <li key={item.key ?? item.label} className="ui-funnel__row">
            <span className="ui-funnel__label">{item.label}</span>
            <div className="ui-funnel__track">
              <span
                className={cx('ui-funnel__bar', index === items.length - 1 && 'ui-funnel__bar--last')}
                style={{ width: `${width}%` }}
              />
            </div>
            <span className="ui-funnel__value">{item.value}</span>
            <span className="ui-funnel__percent">{percent}%</span>
          </li>
        );
      })}
    </ul>
  );
});

export default Funnel;
